
import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator';
import { Sinister } from '../../../../shared/types/sinisters/sinisterInfo';
import NoteForm from '../../../../core/components/Notes/NoteForm.vue';
import { Note } from '../../../../shared/types/notes/notes';
import { ClaimsPort } from '../../../../core/api/ports';
import { InjectionKey } from '../../../../core/injection-keys';
import { enrichNotesWithClassificationNames } from '../../samplings/enrich-notes';

@Component({
  components: {
    NoteForm,
  },
})
export default class InspectionNotes extends Vue {
  @Inject(InjectionKey.ClaimsApi) readonly claimsApi!: ClaimsPort;
  @Prop({ required: true }) sinister!: Sinister;
  @Prop({ type: Boolean, default: false }) showSamplingLabels!: boolean;
  @Prop({ default: () => ({}) }) classificationNames!: Record<number, string>;
  @Prop({ default: () => ({}) }) classificationColors!: Record<number, string>;
  @Prop({ default: null }) selectedNoteId!: number | null;

  fetchNotes(): Promise<Note[]> {
    return this.claimsApi.getSinisterNotes(this.sinister.id)
      .then(res => {
        const notes = res.ranch_notes || [];
        const enriched = this.showSamplingLabels
          ? enrichNotesWithClassificationNames(
              notes,
              this.classificationNames,
              this.classificationColors
            )
          : notes;
        this.seeNotesInMap(enriched);
        return enriched;
      });
  }

  @Emit()
  seeNotesInMap(notes: Note[]) {}

  addNote(note: Note) {
    return this.claimsApi.postNote(this.sinister.id, note);
  }

  updateNote(note: Note) {
    return this.claimsApi.patchNote(note);
  }

  deleteNote(note: Note) {
    return this.claimsApi.deleteNote(note.id as number);
  }
}
